import {
  isEmpty, not, compose, propOr,
} from 'ramda';
import { createSelector } from 'reselect';

export const localeSelector = (state) => state.locale;

export const hasErrorsLocalesSelector = createSelector(
  localeSelector,
  compose(not, isEmpty, propOr({}, 'errors')),
);

export const gamesLocaleSelector = createSelector(
  localeSelector,
  (locale) => locale?.games,
);

export const disabledLocaleSelector = createSelector(
  localeSelector,
  (locale) => Boolean(locale?.isDisabled),
);
